import React from 'react'
import { Upload } from 'hljd'
import style from './index.module.less'

export const ImageViewer = ({ height, width, value }) => {
  return (
    <div className={style.imageViewer}>
      <Upload
        width={width ?? 120}
        height={height ?? 120}
        value={value}
        showUploadList={{
          showRemoveIcon: false
        }}
        max={value.length}
      />
    </div>
  )
}
